
import { Vessel, ImportRecord } from '../types';
import { apiService } from './apiService';

export const getVessels = async (): Promise<Vessel[]> => {
  return await apiService.getVessels();
};

export const saveVessel = async (vessel: Vessel): Promise<void> => {
  await apiService.saveVessel(vessel);
};

export const deleteVessel = async (id: string): Promise<void> => {
  await apiService.deleteVessel(id);
};

export const generateId = (): string => {
  return 'v-' + Math.random().toString(36).substr(2, 9);
};

export const getUniqueManifestValues = async (field: keyof ImportRecord): Promise<string[]> => {
    const vessels = await getVessels();
    const values = new Set<string>();
    vessels.forEach(v => {
        if (v.manifest && Array.isArray(v.manifest)) {
            v.manifest.forEach(m => {
                const val = m[field];
                if (val && typeof val === 'string') {
                    values.add(val);
                }
            });
        }
    });
    return Array.from(values);
};

export const findSimilarExistingName = async (name: string, field: 'importerName' | 'supplier'): Promise<string | null> => {
    const existing = await getUniqueManifestValues(field);
    const normalized = name.trim().toUpperCase();
    return existing.find(ex => ex.trim().toUpperCase() === normalized) || null;
};
